import { render, staticRenderFns } from "./JobTipsModule.vue?vue&type=template&id=18626194"
import script from "./JobTipsModule.vue?vue&type=script&lang=js"
export * from "./JobTipsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports